import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';

export const surveyServices = {
    getUserQuestionsByUserId,
    getStandardQuestions,
    getQuestionById,
    addUserQuestion,
    addStandardQuestion,
    updateUserQuestion,
    deleteUserQuestion,
    getUserSurveyTimeByUserIdAndChildId,
    updateSurveyTime,    
};



function getStandardQuestions(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/GetStandardQuestions/' + userId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getQuestionById(questionId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch('https://spinriseapi.azurewebsites.net/' + questionId , requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

//Start User Question
function getUserQuestionsByUserId(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/GetUserQuestions/' + userId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function addUserQuestion(question) {
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(question)
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/AddUserQuestion', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function updateUserQuestion(question) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(question)
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/UpdateUserQuestion/' + question.questionId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function deleteUserQuestion(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/DeleteUserQuestion/' + id, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}
// End User Question


function addStandardQuestion(standardQuestion) {
    const requestOptions = {
        method: 'POST',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(standardQuestion)
    };

    return fetch('https://spinriseapi.azurewebsites.net/AddStandardQuestions', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}


//Survey time

function getUserSurveyTimeByUserIdAndChildId(userId, childId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/GetSurveyTimes/' + userId+'/'+childId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function updateSurveyTime(question) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            ...authHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(question)
    };

    return fetch(config.apiUrl + '/api/TwilioSurvey/UpdateSurveyTime/' + question.questionId, requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}




// WEBPACK FOOTER //
// ./src/services/survey.service.js